import React from 'react'
import { useQuery } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { getOpenLoopProducts } from '../api'
import { ERROR_GETTING_OPEN_LOOP_PRODUCTS } from '../errorConstants'

const useFetchOpenLoopProducts = ({
    includePlastic,
    includeVirtual,
    cardNetwork,
    limit = 100,
    page = 1,
    category = '',
    isSmb = 0,
    isGift = 0,
}) => {
    const { data, error, isLoading, isSuccess, isError } = useQuery(
        [
            'getOpenLoopProducts',
            {
                includePlastic,
                includeVirtual,
                cardNetwork,
                limit,
                page,
                category,
                isSmb,
                isGift,
            },
        ],
        getOpenLoopProducts,
        {
            onError: (error) => {
                error.name = ERROR_GETTING_OPEN_LOOP_PRODUCTS
                Sentry.captureException(error, {
                    extra: {
                        GCG_SMB_CART: Cookies.get('GCG_SMB_CART'),
                        errorMessage: ERROR_GETTING_OPEN_LOOP_PRODUCTS,
                    },
                    user: {
                        id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                    },
                })
            },
            refetchOnWindowFocus: false,
        }
    )

    return { data, error, isLoading, isSuccess, isError }
}

export default useFetchOpenLoopProducts
